import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { AutoDirDirective } from './directives/auto-dir.directive';
import { ArabicOnlyDirective } from './directives/arabic-only.directive';
import { ArabicKeyboardComponent } from './components/arabic-keyboard/arabic-keyboard.component';

import { HeaderComponent } from './components/header/header.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { MainLayoutComponent } from './components/main-layout/main-layout.component';
import { FederationShellComponent } from './components/federation-shell/federation-shell.component';
import { InvalidFederationComponent } from './components/invalid-federation/invalid-federation.component';
import { NoFederationComponent } from './components/no-federation/no-federation.component';
import { ActualitesListComponent } from '../pages/Communication/actualites/actualites-list/actualites-list.component';
import { ActualitesFormComponent } from '../pages/Communication/actualites/actualites-form/actualites-form.component';
import { ActualitesDetailComponent } from '../pages/Communication/actualites/actualites-detail/actualites-detail.component';
import { ActualitesService } from '../pages/Communication/actualites/actualites.service';
import { CommuniquesListComponent } from '../pages/Communication/communiques/communiques-list/communiques-list.component';
import { CommuniquesFormComponent } from '../pages/Communication/communiques/communiques-form/communiques-form.component';
import { CommuniquesDetailComponent } from '../pages/Communication/communiques/communiques-detail/communiques-detail.component';
import { CommuniquesService } from '../pages/Communication/communiques/communiques.service';
import { RevuesListComponent } from '../pages/Communication/revues-presse/revues-list/revues-list.component';
import { RevuesFormComponent } from '../pages/Communication/revues-presse/revues-form/revues-form.component';
import { RevuesDetailComponent } from '../pages/Communication/revues-presse/revues-detail/revues-detail.component';
import { RevuesPressService } from '../pages/Communication/revues-presse/revues-presse.service';
import { RichTextEditorComponent } from './components/rich-text-editor/rich-text-editor.component';
import { FormulairesListComponent } from '../pages/Communication/formulaires/formulaires-list/formulaires-list.component';
import { FormulairesFormComponent } from '../pages/Communication/formulaires/formulaires-form/formulaires-form.component';
import { FormulairesDetailComponent } from '../pages/Communication/formulaires/formulaires-detail/formulaires-detail.component';
import { FormulairesService } from '../pages/Communication/formulaires/formulaires.service';
import { MediatiqueListComponent } from '../pages/Communication/mediatique/mediatique-list/mediatique-list.component';
import { MediatiqueDetailComponent } from '../pages/Communication/mediatique/mediatique-detail/mediatique-detail.component';
import { MediatiqueFormComponent } from '../pages/Communication/mediatique/mediatique-form/mediatique-form.component';
import { MediatiqueService } from '../pages/Communication/mediatique/mediatique.service';
import { PartenairesComponent } from '../pages/Communication/partenaires/partenaires.component';
import { DocumentsPublicComponent } from '../pages/Management/documents-public/documents-public.component';
import { DocumentsPublicDetailComponent } from '../pages/Management/documents-public/documents-public-detail/documents-public-detail.component';
import { IntInstancesListComponent } from '../pages/Management/int-instances/int-instances-list.component';
import { HistoryEventsListComponent } from '../pages/Management/history-events/history-events-list.component';
import { DocumentsListComponent } from '../pages/Management/documents-manager/documents-list.component';
import { MeetingsListComponent } from '../pages/Communication/meetings/meetings-list/meetings-list.component';
import { MeetingsFormComponent } from '../pages/Communication/meetings/meetings-form/meetings-form.component';
import { MeetingsDetailComponent } from '../pages/Communication/meetings/meetings-detail/meetings-detail.component';
import { MeetingsService } from '../pages/Communication/meetings/meetings.service';
import { SocialMediaListComponent } from '../pages/Communication/social-media/social-media-list/social-media-list.component';
import { SocialMediaFormComponent } from '../pages/Communication/social-media/social-media-form/social-media-form.component';
import { SocialMediaService } from '../pages/Communication/social-media/social-media.service';
import { TagInputComponent } from './components/tag-input/tag-input.component';
import { TagChipsComponent } from './components/tag-chips/tag-chips.component';
import { TagsService } from './services/tags.service';

@NgModule({
  declarations: [
    AutoDirDirective,
    ArabicOnlyDirective,
    ArabicKeyboardComponent,
    HeaderComponent,
    SidebarComponent,
    MainLayoutComponent,
    FederationShellComponent,
    InvalidFederationComponent,
    NoFederationComponent,
    ActualitesListComponent,
    ActualitesFormComponent,
    ActualitesDetailComponent,
    CommuniquesListComponent,
    CommuniquesFormComponent,
    CommuniquesDetailComponent,
    RevuesListComponent,
    RevuesFormComponent,
    RevuesDetailComponent,
    RichTextEditorComponent,
    FormulairesListComponent,
    FormulairesFormComponent,
    FormulairesDetailComponent,
    MediatiqueListComponent,
    MediatiqueDetailComponent,
    MediatiqueFormComponent,
    PartenairesComponent,
    DocumentsPublicComponent,
    DocumentsPublicDetailComponent,
    IntInstancesListComponent,
    HistoryEventsListComponent,
    DocumentsListComponent,
    MeetingsListComponent,
    MeetingsFormComponent,
    MeetingsDetailComponent,
    SocialMediaListComponent,
    SocialMediaFormComponent,
    TagInputComponent,
    TagChipsComponent,
  ],
  imports: [CommonModule, RouterModule, FormsModule],
  exports: [
    CommonModule,
    RouterModule,
    FormsModule,
    AutoDirDirective,
    ArabicOnlyDirective,
    ArabicKeyboardComponent,
    HeaderComponent,
    SidebarComponent,
    MainLayoutComponent,
    FederationShellComponent,
    InvalidFederationComponent,
    NoFederationComponent,
    ActualitesListComponent,
    ActualitesFormComponent,
    ActualitesDetailComponent,
    CommuniquesListComponent,
    CommuniquesFormComponent,
    CommuniquesDetailComponent,
    RevuesListComponent,
    RevuesFormComponent,
    RevuesDetailComponent,
    RichTextEditorComponent,
    FormulairesListComponent,
    FormulairesFormComponent,
    FormulairesDetailComponent,
    MediatiqueListComponent,
    MediatiqueDetailComponent,
    MediatiqueFormComponent,
    PartenairesComponent,
    DocumentsPublicComponent,
    DocumentsPublicDetailComponent,
    IntInstancesListComponent,
    HistoryEventsListComponent,
    DocumentsListComponent,
    MeetingsListComponent,
    MeetingsFormComponent,
    MeetingsDetailComponent,
    SocialMediaListComponent,
    SocialMediaFormComponent,
    TagInputComponent,
    TagChipsComponent,
  ],
  providers: [ActualitesService, CommuniquesService, RevuesPressService, FormulairesService, MediatiqueService, MeetingsService, SocialMediaService, TagsService]
})
export class SharedModule {}
